var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"benchmarks"}},[_c('card',{attrs:{"icon":"compass","headline":_vm.$t('visitors.benchmarks.headline'),"description":_vm.$t('visitors.benchmarks.description')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }